module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back kaoji-box",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "kaoji-title"
  }, [_vm._v(_vm._s(_vm.row.danwei) + _vm._s(_vm.row.kaojitype))]), _vm._v(" "), _c('van-cell-group', [_c('div', {
    staticClass: "kaoji-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.row.pic_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级单位名称",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级单位级别",
      "value": _vm.row.bgrade
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级单位地址",
      "value": _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "客服电话",
      "value": _vm.row.contactsphone
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [(_vm.row.is_join) ? _c('van-button', {
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("您已经是该俱乐部的成员\n    ")]) : _c('van-button', {
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.userShow = true
      }
    }
  }, [_vm._v("绑定为我的俱乐部\n    ")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '50%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.userShow),
      callback: function($$v) {
        _vm.userShow = $$v
      },
      expression: "userShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.submit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("请输入联系人" + _vm._s(_vm.row.contactsname) + "的身份证号码进行验证")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": _vm.row.contactsname + '的身份证号',
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("确认绑定\n          ")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5999d0c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailUnbind.vue
// module id = 2420
// module chunks = 0